<template>
    <div class="layout-full-page">
        <div class="container">
            <div class="login">
                <div class="row justify-content-center">
                    <div class="col-md-12 col-lg-10">
                        <div class="login-wrap d-md-flex">
                            <div class="login-img"></div>
                            <div class="login-box p-4 p-md-5">
                                <div class="login-logo mb-3 d-flex justify-content-center flex-column">
                                    <img
                                        src="../assets/brand/logo_gastouderapp.svg"
                                        alt="Gastouderapp logo"
                                    />
                                </div>
                                <h6 class="fw-bold">Wachtwoord aanmaken of vergeten</h6>
                                <p>Geen probleem, we sturen je binnen enkele minuten de informatie om een nieuw wachtwoord in te stellen.</p>
                                <div class="mb-4">
                                    <div
                                        v-if="error && error.error_message"
                                        class="alert alert-danger"
                                        role="alert"
                                    >
                                        {{ error.error_message }}
                                    </div>
                                    <div class="mb-2">
                                        <label
                                            class="form-label"
                                            for="usernameInput"
                                        >E-mailadres</label>
                                        <input
                                            class="form-control"
                                            id="usernameInput"
                                            type="email"
                                            v-model="username"
                                            autofocus
                                        />
                                    </div>
                                    <div class="mb-2">
                                        <label
                                            class="form-label"
                                            for="clientnumberInput"
                                        >Klantnummer</label>
                                        <input
                                            class="form-control"
                                            id="clientnumberInput"
                                            type="text"
                                            v-model="clientNumber"
                                        />
                                    </div>
                                    <div class="d-grid gap-3">
                                        <button
                                            class="btn btn-info mt-3"
                                            v-on:click="resetPassword"
                                        >Nieuw wachtwoord aanvragen</button>
                                        <a
                                            href="/gastouderapp/login/gastouder"
                                            class="text-center small"
                                        >Terug naar inloggen</a>
                                    </div>
                                </div>
                                <p class="text-center small text-body-secondary mb-2">
                                    {{ app.name }} {{ app.tag }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "forgot-password-form",
    components: {

    },
    data() {
        return {
            isLoading: false,
            error: null,
            username: null,
            clientNumber: null
        };
    },
  created() {
  },
  methods: {
    resetPassword() {
      this.error = null
      this.isLoading = true
      this.$request.post('/forgot-password', {
          username: this.username,
          client_number: this.clientNumber
        })
        .then((response) => {
          if (confirm(response.message)) {
              window.location.href = '/gastouderapp/login/gastouder'
          }
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          if (error && error.error) {
            this.error = error.error
          } else {
            this.error = {
              error_message:
                "Er ging iets mis, controleer de verbinding en probeer opnieuw",
            };
          }
        });
    },
  },
};
</script>

<style scoped>
</style>
